import React from 'react';
import OneLevelList from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/OneLevelList/OneLevelList';

const OneListByMapContainer = ({ map, ...props }) => {
  const items = props.items.reduce((acc, item) => (
      map[item.value] ? [...acc, { ...item, name: map[item.value] }] : acc
  ), []);

  return <OneLevelList { ...props } items={ items } />;
};

export default OneListByMapContainer;
